import {DialogComponent} from './dialog/dialog.component';
import {Observable} from 'rxjs';
import {DialogWrapperComponent} from './dialog-wrapper/dialog-wrapper.component';
import {MatDialogRef} from '@angular/material/dialog';


export  class Dialog<R> {
    readonly dialogRef: MatDialogRef<DialogWrapperComponent<R, any, any>, R>;

    constructor(dialogRef: MatDialogRef<DialogWrapperComponent<R, any, any>, R>) {
        this.dialogRef = dialogRef;
    }

    afterClosed(): Observable<R | undefined> {
        return this.dialogRef.afterClosed();
    }

    close(dialogResult?: R): void {
        this.dialogRef.close(dialogResult);
    }
}
